import textSettingComplex from "../propComponents/textSettingComplex.vue"
import textSettingComplexUpdate from "../propComponents/textSettingComplex_update.vue"
import cxBorder from "../propComponents/cxBorder.vue";
import cxBackground from "../propComponents/cxBackground.vue";
import  cxSlider from "../propComponents/sliderAndInput.vue"
import cxColorPicker from "../propComponents/cxColorPicker.vue";
import cxPadding from "../propComponents/cxPadding.vue";
import borderRadius from "../propComponents/borderRadius.vue";
import boxShadow from "../propComponents/boxShadow.vue";
import cxSize from './../propComponents/cxSize.vue'
import cxSite from './../propComponents/cxSite.vue'
import iconSet from './../propComponents/iconSet.vue'
import booleanSet from './../propComponents/cxBoolean.vue'
import sliderSet from './../propComponents/cxSlider.vue'
import uploadSet from './../propComponents/fileUpload.vue'
import marginSet from './../propComponents/margin.vue'
import inputSet from './../propComponents/inputSet.vue'
import simpleTextSetting from "../propComponents/simpleTextSetting.vue";
import cxCheckBoxGroup from "../propComponents/cxCheckBoxGroup.vue"
import cxDivide from "../propComponents/cxDivide.vue"
import cxSelect from '../propComponents/cxSelect.vue'
import connectorSet from '../propComponents/connectorSet.vue'

export default {
  components: {
    paddingSet: cxPadding,
    borderSet: cxBorder,
    backgroundSet: cxBackground,
    fontSet: textSettingComplex,
    complexFontSet: textSettingComplexUpdate,
    simpleFontSet: simpleTextSetting,
    numberSet: cxSlider,
    colorSet: cxColorPicker,
    radiusSet: borderRadius,
    shadowSet: boxShadow,
    sizeSet: cxSize,
    iconSet: iconSet,
    booleanSet,
    sliderSet,
    uploadSet,
    marginSet,
    cxSite,
    inputSet,
    checkBoxGroupSet: cxCheckBoxGroup,
    divideSet:cxDivide,
    selectSet: cxSelect,
    connectorSet
  }
}